import styled from "styled-components";
import Navbar from "react-bootstrap/Navbar";
import { Button, Collapse, Drawer } from "antd";
import { DownOutlined, BellOutlined } from "@ant-design/icons";
import Container from "react-bootstrap/Container";
import { LAUNCHER_LEFT_CLASS } from "../common/IntercomGate";

export const XMobHeader = styled.section`
  width: 100%;
  position: relative;
  display: none;
  padding: 0px;
  @media only screen and (max-width: 991.99px) {
    display: block;
    position: fixed;
    width: 100%;
    top: 0px;
    left: 0px;
    right: 0px;
    z-index: 99;
    height: 60px;
    padding: 0 16px;
    background-color: ${({ theme }) => theme.settings.whiteColor};
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);
  }
`;

export const XMobHeaderBar = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  width: 100%;
  height: 60px;
`;

export const XMobHeaderSide = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;

  &.right {
    justify-content: flex-end;
  }

  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;

export const XMobHamburger = styled(Button)`
  border: none;
  background-color: transparent;
  color: ${({ theme }) => theme.settings.primary};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 36px;
  font-size: 22px;
  padding: 0;
  margin: 0;
  height: 36px;
  width: 36px;
  line-height: 1;
  &:hover,
  &:focus,
  &:active {
    background-color: transparent;
    color: ${({ theme }) => theme.settings.primary} !important;
  }
`;

export const XMobLogo = styled.img`
  display: block;
  width: 106px;
  max-width: 100%;
  height: 28px;
  object-fit: contain;
`;

export const XMobDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 60px 0px 16px 0px;
  }
  /* Phones: the Intercom launcher sits bottom-left, over this drawer (IntercomGate
     body class). Room at the end so the last menu entry scrolls clear of it. */
  body.${LAUNCHER_LEFT_CLASS} & .ant-drawer-body {
    padding-bottom: 84px;
  }
  .ant-drawer-header {
    border: none;
    padding: 0;
    .ant-drawer-header-title {
      position: absolute;
      top: 80px;
      right: -45px;
      z-index: 1;
      button {
        font-size: 24px;
        color: ${({ theme }) => theme.settings.whiteColor};
        &:hover {
          color: ${({ theme }) => theme.settings.whiteColor};
        }
      }
    }
  }
`;

export const XMobMenuList = styled.div`
  display: flex;
  flex-direction: column;
  background: transparent;
`;

export const XMobMenuItem = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.settings.borderColor};
  background-color: ${({ $active, theme }) =>
    $active ? theme.settings.whiteColor : "transparent"};
  a {
    font-family: ${({ theme }) => theme.fonts.inter};
    display: block;
    padding: 15px 20px;
    text-decoration: none;
    color: inherit;
    transition: background-color 0.2s ease;
    font-size: 14px;
    font-weight: ${({ $active }) => ($active ? 600 : 500)};
    color: ${({ theme }) => theme.settings.primary};
    &:hover {
      background-color: ${({ theme }) => theme.settings.whiteColor};
    }
    img,
    svg {
      width: 16px;
      height: 16px;
      margin-right: 5px;
      color: ${({ theme }) => theme.settings.primary};
      filter: ${({ theme }) => theme.settings.imgFilterColor};
    }
  }
`;

// Keep the old components for backward compatibility if needed elsewhere
export const XMobMenuCollapse = styled(Collapse)`
  background: transparent;
  border: none;
  .anticon {
    margin-right: 5px;
  }
  .ant-collapse-content-box {
    padding: 0px !important;
  }
  .ant-collapse-item {
    border-bottom: 1px solid ${({ theme }) => theme.settings.borderColor};
    &:last-child {
      border-radius: 0px;
      border-bottom: 1px solid ${({ theme }) => theme.settings.borderColor};
    }
  }
  .ant-collapse-item-active {
    border-bottom: 1px solid ${({ theme }) => theme.settings.borderColor};
  }
`;

export const XMobSubMenuCollapse = styled(Collapse)`
  display: flex;
  flex-direction: column;
  background: transparent;
  border: none;
  .anticon {
    margin-right: 5px;
  }
  .ant-collapse-item {
    border-bottom: 1px solid ${({ theme }) => theme.settings.borderColor};
    padding: 0px 5px !important;
    &:last-child {
      border-radius: 0px;
      border-bottom: none;
    }
  }

  .ant-collapse-item-active {
    border-bottom: 1px solid ${({ theme }) => theme.settings.borderColor};
  }

  .ant-collapse-expand-icon {
    display: block !important;
    height: auto !important;
  }

  .ant-collapse-arrow {
    display: block !important;
    height: auto !important;
  }

  .ant-collapse-header {
    padding: 0px !important;
    align-items: center !important;
    background: transparent;
    border: none;
    padding: 0px 15px !important;
  }

  .ant-collapse-content {
    .ant-collapse-content-box {
      padding-left: 32px !important;
      padding-right: 16px !important;
    }
  }

  /* Hide the expand arrow icon */
  .ant-collapse-expand-icon {
    display: none !important;
  }

  /* Alternative: Hide the arrow icon specifically */
  .ant-collapse-arrow {
    display: none !important;
  }

  /* Ensure no space is reserved for the arrow */
  .ant-collapse-header {
    padding: 0px;
  }

  /* Ensure links are properly aligned */
  a {
    display: block;
    padding: 10px 0;
    text-decoration: none;
    color: inherit;
  }
`;
